var _style, _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Schriftzug",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 72",
    style: {
      enableBackground: "new 0 0 110 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#B4CCDD;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36,26.1V16h3.7l2.2,6.8l2.2-6.8h3.7v10h-2.3v-7.9L43,26h-2.4l-2.4-7.9V26L36,26.1L36,26.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.6,26.1v-4.2L49.1,16H52l2.9,4l2.8-4h2.9l-4.5,5.8V26L53.6,26.1L53.6,26.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60,26.1v-1.9h2.4v1.9H60z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.7,26.1v-1.8l6.5-6.5h-5.8V16h9v1.6l-6.8,6.8h7v1.7H63.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.7,22.8l2.4-0.2c0.1,0.7,0.4,1.1,0.9,1.5c0.4,0.3,1,0.5,1.8,0.5s1.4-0.1,1.8-0.4c0.4-0.3,0.6-0.6,0.6-1 c0-0.2-0.1-0.4-0.3-0.6c-0.2-0.2-0.5-0.3-0.9-0.4c-0.3-0.1-1-0.2-2-0.4c-1.3-0.3-2.3-0.6-2.8-1c-0.8-0.6-1.1-1.2-1.1-2 c0-0.5,0.2-1,0.5-1.4c0.4-0.4,0.9-0.8,1.5-1c0.7-0.2,1.5-0.3,2.4-0.3c1.6,0,2.7,0.3,3.5,0.8c0.8,0.6,1.2,1.3,1.2,2.2L81.9,19 c-0.1-0.5-0.3-0.9-0.7-1.1c-0.4-0.2-0.9-0.3-1.6-0.3s-1.3,0.1-1.7,0.4c-0.3,0.2-0.4,0.4-0.4,0.6c0,0.2,0.1,0.4,0.4,0.6 c0.3,0.2,1.1,0.4,2.3,0.7s2.1,0.5,2.7,0.7s1,0.6,1.4,1c0.3,0.4,0.5,1,0.5,1.6s-0.2,1.1-0.6,1.6s-0.9,0.9-1.7,1.1s-1.6,0.4-2.7,0.4 c-1.6,0-2.8-0.3-3.6-0.9C75.4,24.8,74.9,23.9,74.7,22.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.9,26.1V16h2.5v4.5l5-4.5h3.4l-4.7,3.9L98,26h-3.2l-3.4-4.7l-2,1.7v3L86.9,26.1L86.9,26.1z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.9,
    y: 15.1,
    className: "st1",
    width: 6,
    height: 11
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 17.1,
    className: "st0",
    width: 6,
    height: 9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1,
    y: 11.1,
    className: "st1",
    width: 6,
    height: 15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDefault);
export default __webpack_public_path__ + "static/media/home-default.3c796d5feaa5bc856892deb6cc4d87a6.svg";
export { ForwardRef as ReactComponent };